module.exports = __webpack_public_path__ + "img/drug_card_layout__same__sv.d72a1e5b.png";